// Local, once-a-day gating for the Daily Ritual (works for guests and members).
const KEY = "lumina_daily_v1";

export function todayStr() {
  // Local calendar date, e.g. "2026-06-14"
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export function getTodayDraw() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed?.date === todayStr() ? parsed : null;
  } catch (err) {
    console.error("Failed to read daily draw from localStorage", err);
    return null;
  }
}

export function saveTodayDraw(data) {
  try {
    localStorage.setItem(KEY, JSON.stringify({ ...data, date: todayStr() }));
  } catch (err) {
    console.error("Failed to save daily draw to localStorage", err);
  }
}

export function msUntilMidnight() {
  const now = new Date();
  const next = new Date(now);
  next.setHours(24, 0, 0, 0);
  return next.getTime() - now.getTime();
}

export function formatCountdown(ms) {
  if (ms <= 0) return "now";
  const totalMin = Math.floor(ms / 60000);
  const h = Math.floor(totalMin / 60);
  const m = totalMin % 60;
  if (h > 0) return `${h}h ${m}m`;
  return `${m}m`;
}

// ---------------- Ritual streak (local, gentle) ----------------
const STREAK_KEY = "lumina_streak_v1";

function yesterdayStr() {
  const d = new Date();
  d.setDate(d.getDate() - 1);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export function getStreak() {
  try {
    const raw = localStorage.getItem(STREAK_KEY);
    if (!raw) return { count: 0, best: 0, lastDate: null };
    return JSON.parse(raw);
  } catch (err) {
    return { count: 0, best: 0, lastDate: null };
  }
}

// Call once when today's ritual completes. Idempotent per day.
export function recordStreak() {
  const today = todayStr();
  const s = getStreak();
  if (s.lastDate === today) return s;
  const count = s.lastDate === yesterdayStr() ? (s.count || 0) + 1 : 1;
  const best = Math.max(s.best || 0, count);
  const next = { count, best, lastDate: today };
  try {
    localStorage.setItem(STREAK_KEY, JSON.stringify(next));
  } catch (err) {
    /* ignore quota errors */
  }
  return next;
}

// Streak to show before drawing: 0 if the chain has lapsed (missed a day).
export function currentStreakDisplay() {
  const s = getStreak();
  if (!s.lastDate) return 0;
  if (s.lastDate === todayStr() || s.lastDate === yesterdayStr()) return s.count || 0;
  return 0;
}
